module.exports = __webpack_public_path__ + "img/birthday-club.155ac424.svg";